// extracted by mini-css-extract-plugin
export default {"survey":"Survey_survey__J1XQ0","button":"Survey_button__DOZ3r"};